import './CalculateSplitForm.css';
import CurrencyInput, {formatValue} from 'react-currency-input-field';
import {useEffect, useState} from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {Card, Col, Container, Dropdown, Modal, Navbar, Row} from "react-bootstrap";
import CalculateSplitResult from "./CalculateSplitResult";
import CalculateMatchResult from "./CalculateMatchResult";
import CalculateSaveResult from "./CalculateSaveResult";
import bcrypt from 'bcryptjs';

const fairShareUrl = process.env.REACT_APP_FAIRSHARE_URL;

function CalculateSplitForm() {

  const INPUT_TYPES = {
    SPLIT: 'split',
    MATCH: 'match',
    SAVE: 'save'
  };

  const prefix = '£';

  const [showIncomeModal, setShowIncomeModal] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);

  const [inputs, setInputs] = useState({
    inputAmount: '',
    months: '24',
    personOneIncome: '',
    personTwoIncome: '',
    splitResult: {
      personOneSplit: '',
      personTwoSplit: '',
    },
    saveResult: {
      personOneSplit: '',
      personTwoSplit: '',
    },
    matchResult: {
      person: '1',
      matchAmount: '',
      total: '',
    },
    showResult: false,
    inputType: INPUT_TYPES.SPLIT
  });

  useEffect(() => {
    getDefaultIncomes();
  }, []);

  const handleChange = (value, name) => {
    setInputs(values => ({...values, [name]: value}));
  };

  const onSaveChange = (e) => {
    inputs.months = e.target.value;
    inputs.showResult = true;
    handleSubmit(e)
  };

  async function saveIncomes() {
    const response = await fetch(
        fairShareUrl + '/defaultIncomes',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            password: bcrypt.hashSync(password, 10),
            incomes: {
              personOneIncome: inputs.personOneIncome,
              personTwoIncome: inputs.personTwoIncome
            }
          })
        }
    );

    if (response.ok) {
      setPassword('');
      setPasswordError(false);
      setShowIncomeModal(false);
    } else if (response.status === 401) {
      setPasswordError(true);
    }
  }

  async function getDefaultIncomes() {
    const response = await fetch(
        '/runtime-config/default-incomes.json',
        { cache: 'no-cache' }
    );

    if (!response.ok) {
      throw new Error('Failed to load default incomes');
    }

    const data = await response.json();

    setInputs(values => ({
      ...values,
      personOneIncome: data.personOneIncome,
      personTwoIncome: data.personTwoIncome
    }));
  }

  async function getSplitAmounts() {
    const response = await fetch(
        fairShareUrl + '/getSplitAmounts',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "splitAmount": inputs.inputAmount,
            "incomes": {
              "personOneIncome": inputs.personOneIncome,
              "personTwoIncome": inputs.personTwoIncome
            }
          })
        });

    const data = await response.json();
    setInputs(values => ({
      ...values,
      splitResult: {
        personOneSplit: formatValue({
          prefix, value: String(data.personOneSplit), decimalScale: 2
        }),
        personTwoSplit: formatValue({
          prefix, value: String(data.personTwoSplit), decimalScale: 2
        })
      },
      showResult: true
    }));
  }

  async function getMatchAmount() {
    const response = await fetch(
        fairShareUrl + '/getMatchAmount',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "matchAmount": inputs.inputAmount,
            "person": inputs.matchResult.person,
            "incomes": {
              "personOneIncome": inputs.personOneIncome,
              "personTwoIncome": inputs.personTwoIncome
            }
          })
        });

    const data = await response.json();
    inputs.matchResult.matchAmount = formatValue({
      prefix, value: String(data.matchAmount), decimalScale: 2
    })
    inputs.matchResult.total = formatValue({
      prefix, value: String(data.total), decimalScale: 2
    })
  }

  async function getSaveAmount() {
    const response = await fetch(
        fairShareUrl + '/getSaveAmount',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "saveAmount": inputs.inputAmount,
            "months": inputs.months,
            "incomes": {
              "personOneIncome": inputs.personOneIncome,
              "personTwoIncome": inputs.personTwoIncome
            }
          })
        });

    const data = await response.json();
    inputs.saveResult.personOneSplit = formatValue({
      prefix, value: String(data.personOneSplit), decimalScale: 2
    })
    inputs.saveResult.personTwoSplit = formatValue({
      prefix, value: String(data.personTwoSplit), decimalScale: 2
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (inputs.inputType === INPUT_TYPES.SPLIT) {
      await getSplitAmounts();
    } else if (inputs.inputType === INPUT_TYPES.MATCH) {
      await getMatchAmount();
    } else {
      await getSaveAmount();
    }
    inputs.showResult = true
    setInputs(values => ({...values}))
  }

  function radioChange(e) {
    inputs.inputType = e.target.value;
    inputs.showResult = false;
    setInputs(values => ({...values}))
    if (!(inputs.inputType === INPUT_TYPES.SPLIT) && inputs.inputAmount
        && inputs.personOneIncome && inputs.personTwoIncome
        && inputs.matchResult.person) {
      void handleSubmit(e)
    }
  }

  function personRadioChange(e) {
    inputs.matchResult.person = e.target.value;
    void handleSubmit(e)
  }

  return (
      <div>
        {/* BURGER MENU */}
        <Navbar className="justify-content-end px-3">
          <Dropdown align="end">
            <Dropdown.Toggle variant="light">
              ⚙️
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => {
                setPasswordError(false);
                setShowIncomeModal(true);
              }}>
                Set incomes
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Navbar>
        <Container className="vertical-center">
          <Row>
            <Col className="center">
              <Form onSubmit={handleSubmit}>
                <h1 className="center">FairShare 💸</h1>
                <Form.Group className="mb-4 center">
                  <CurrencyInput
                      name="personOneIncome"
                      placeholder="Person One's Income"
                      value={inputs.personOneIncome}
                      decimalsLimit={2}
                      prefix={prefix}
                      onValueChange={(value, name) => handleChange(value, name)}
                  />
                </Form.Group>
                <Form.Group className="mb-4 center">
                  <CurrencyInput
                      name="personTwoIncome"
                      placeholder="Person Two's Income"
                      value={inputs.personTwoIncome}
                      decimalsLimit={2}
                      prefix={prefix}
                      onValueChange={(value, name) => handleChange(value, name)}
                  />
                </Form.Group>
                <Form.Group className="mb-4 center">
                  <CurrencyInput
                      name="inputAmount"
                      placeholder={"Amount to " + inputs.inputType}
                      value={inputs.inputAmount}
                      decimalsLimit={2}
                      prefix={prefix}
                      onValueChange={(value, name, values) => handleChange(
                          value,
                          name, values)}
                  />
                </Form.Group>
                {inputs.inputType === INPUT_TYPES.SAVE ? (
                    <Form.Group className="mb-4">
                      <Form.Label className="center">Number of Months to
                        Save: {inputs.months}</Form.Label>
                      <Form.Range
                          name="months"
                          min="1"
                          max="120"
                          value={inputs.months || ""}
                          onChange={onSaveChange}
                          disabled={!inputs.inputAmount}
                          className="center"/>
                    </Form.Group>) : null
                }
                <div key={`inline-radio`} className="mb-3 center">
                  <Form.Check
                      inline
                      label="Split Amount"
                      name="radioGroup"
                      type="radio"
                      value="split"
                      checked={inputs.inputType === INPUT_TYPES.SPLIT}
                      id="inline-radio-split"
                      onChange={radioChange}
                  />
                  <Form.Check
                      inline
                      label="Match Amount"
                      name="radioGroup"
                      type="radio"
                      value="match"
                      checked={inputs.inputType === INPUT_TYPES.MATCH}
                      id="inline-radio-match"
                      onChange={radioChange}
                  />
                  <Form.Check
                      inline
                      label="Save Amount"
                      name="radioGroup"
                      type="radio"
                      value="save"
                      checked={inputs.inputType === INPUT_TYPES.SAVE}
                      id="inline-radio-save"
                      onChange={radioChange}
                  />
                </div>

                {inputs.inputType === "match" ? (
                    <div key={`inline-radio-pers`} className="mb-3 center">
                      <Form.Check
                          inline
                          label="Person One"
                          name="personRadioGroup"
                          type="radio"
                          value="1"
                          checked={inputs.matchResult.person === "1"}
                          id="inline-radio-pers-one"
                          onChange={personRadioChange}
                          disabled={!inputs.inputAmount
                              || !inputs.personOneIncome
                              || !inputs.personTwoIncome}
                      />
                      <Form.Check
                          inline
                          label="Person Two"
                          name="personRadioGroup"
                          type="radio"
                          value="2"
                          checked={inputs.matchResult.person === "2"}
                          id="inline-radio-pers-two"
                          onChange={personRadioChange}
                          disabled={!inputs.inputAmount
                              || !inputs.personOneIncome
                              || !inputs.personTwoIncome}
                      />
                    </div>) : null
                }
                <div className="center">
                  <Button variant="primary" type="submit"
                          disabled={!inputs.inputAmount
                              || !inputs.personOneIncome
                              || !inputs.personTwoIncome}
                          hidden={!(inputs.inputType === INPUT_TYPES.SPLIT)}>
                    Submit
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col className="center">
              <div id="result">
                {inputs.showResult ? (
                        <Card>
                          {inputs.inputType === INPUT_TYPES.SPLIT ? (
                              <CalculateSplitResult splits={{
                                personOneSplit: inputs.splitResult.personOneSplit,
                                personTwoSplit: inputs.splitResult.personTwoSplit
                              }}/>
                          ) : (
                              inputs.inputType === INPUT_TYPES.MATCH ? (
                                  <CalculateMatchResult matchResult={{
                                    matchAmount: inputs.matchResult.matchAmount,
                                    total: inputs.matchResult.total
                                  }}/>
                              ) : (
                                  <CalculateSaveResult saveResult={{
                                    personOneSplit: inputs.saveResult.personOneSplit,
                                    personTwoSplit: inputs.saveResult.personTwoSplit
                                  }}/>
                              )
                          )
                          }
                        </Card>
                    )
                    : null
                }
              </div>
            </Col>
          </Row>
        </Container>
        {/* INCOME MODAL */}
        <Modal show={showIncomeModal}
               onHide={() => {
                 setShowIncomeModal(false);
                 setPasswordError(false);
               }}
               centered>
          <Modal.Header closeButton>
            <Modal.Title>Set incomes</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Income One</Form.Label>
              <CurrencyInput
                  value={inputs.personOneIncome}
                  decimalsLimit={2}
                  prefix={prefix}
                  onValueChange={(value) =>
                      handleChange(value, 'personOneIncome')}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Income Two</Form.Label>
              <CurrencyInput
                  value={inputs.personTwoIncome}
                  decimalsLimit={2}
                  prefix={prefix}
                  onValueChange={(value) =>
                      handleChange(value, 'personTwoIncome')}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                  type="password"
                  value={password}
                  isInvalid={passwordError}
                  onChange={e => {
                    setPassword(e.target.value);
                    setPasswordError(false);
                  }}
              />
              <Form.Control.Feedback type="invalid">
                Incorrect password
              </Form.Control.Feedback>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary"
                    onClick={() => {
                      setShowIncomeModal(false);
                      setPasswordError(false);
                    }}>
              Cancel
            </Button>
            <Button variant="primary" onClick={saveIncomes}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <div>
          <h5>
            Other projects:
            <ul>
              <li>
                <a href="/pokerGame">Poker Game</a>
              </li>
            </ul>
          </h5>
        </div>
      </div>
  )
}

export default CalculateSplitForm;